(function(){
  'use strict';
  function init(root){
    if(root.dataset.vjGalleryReady==='true')return;
    var slides=Array.prototype.slice.call(root.querySelectorAll('[data-vj-gallery-slide]'));
    var controls=root.querySelector('[data-vj-gallery-controls]');
    var previous=root.querySelector('[data-vj-gallery-prev]');
    var next=root.querySelector('[data-vj-gallery-next]');
    var count=root.querySelector('[data-vj-gallery-count]');
    var scene=root.querySelector('[data-vj-gallery-scene]');
    if(!slides.length||!controls||!previous||!next||!count||!scene)return;
    root.dataset.vjGalleryReady='true';
    var index=0;
    var isMultiple=slides.length>1;
    controls.hidden=!isMultiple;
    function activate(value){
      index=(value+slides.length)%slides.length;
      slides.forEach(function(slide,i){
        slide.classList.toggle('is-active',i===index);
        slide.setAttribute('aria-hidden',i===index?'false':'true');
      });
      var text=slides[index].querySelector('[data-vj-scene-name]');
      scene.textContent=text?text.textContent:'The Dining Room';
      count.textContent=String(index+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
    }
    activate(0);
    if(!isMultiple)return;
    previous.addEventListener('click',function(){activate(index-1);});
    next.addEventListener('click',function(){activate(index+1);});
    root.setAttribute('tabindex','0');
    root.addEventListener('keydown',function(event){
      if(event.target!==root)return;
      if(event.key==='ArrowLeft'||event.key==='ArrowRight'){
        event.preventDefault();
        activate(index+(event.key==='ArrowRight'?1:-1));
      }
    });
    var x=0,y=0;
    root.addEventListener('touchstart',function(e){
      if(e.touches.length!==1)return;
      x=e.touches[0].clientX;y=e.touches[0].clientY;
    },{passive:true});
    root.addEventListener('touchend',function(e){
      if(e.changedTouches.length!==1)return;
      var dx=e.changedTouches[0].clientX-x;
      var dy=e.changedTouches[0].clientY-y;
      if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.3)activate(index+(dx<0?1:-1));
    },{passive:true});
  }
  document.querySelectorAll('[data-vj-gallery]').forEach(init);
  document.addEventListener('shopify:section:load',function(event){
    if(event.target.matches('[data-vj-gallery]'))init(event.target);
    event.target.querySelectorAll('[data-vj-gallery]').forEach(init);
  });
})();
